export default __webpack_public_path__ + "static/media/inv-dash.8cac5a1b.png";